import { Row } from "antd";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../components/Header";
import { bucket_base_url, FALLBACK_IMAGE } from "../../constants/constant";
import { decodeHtmlEntities } from "../../utils/Helper";
import { imageCache } from "../../utils/constant";

const BlogDetails = () => {
  const { state } = useLocation();
  const heroUrl = state?.id?.file?.[0]?.filePath
    ? `${bucket_base_url}${state.id.file[0].filePath}`
    : FALLBACK_IMAGE;

  // Warm the cache so navigating back or revisiting is instant
  useEffect(() => {
    if (heroUrl && heroUrl !== FALLBACK_IMAGE && !imageCache.has(heroUrl)) {
      const img = new window.Image();
      img.src = heroUrl;
      img.onload = () => imageCache.set(heroUrl, true);
      img.onerror = () => imageCache.set(heroUrl, true);
    }
  }, [heroUrl]);

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Header />
      <div className="blog-details-image">
        <img
          src={heroUrl}
          alt="blog"
          className="blog-details-image-2"
          loading="eager"
          fetchPriority="high"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = FALLBACK_IMAGE;
          }}
        />
      </div>
      <div style={{ position: "relative" }}>
        <div
          style={{
            height: "81px",
            position: "fixed",
            top: "0px",
            width: "100%",
            zIndex: 1,
          }}
        ></div>
        <Row className="blogTitle">{state?.id?.title}</Row>

        <div
          className="blog-details"
          dangerouslySetInnerHTML={{
            __html: decodeHtmlEntities(state?.id?.content),
          }}
        />
      </div>
    </div>
  );
};

export default BlogDetails;
